<template>
	<div class="root">
		<div class="content">
			<!-- <div class="title-bar"><img src="./images/serviceProvider/title.png"></div> -->
			<!-- <div class="title-banner">
				<img src="./images/serviceProvider/banner.png">
			</div> -->
			<div class="item-first" >
				<div class="item-qrcode">
					<div class="qrcode" id="qrcode" ref="qrcode"></div>
				</div>
				<div class="item-content">
					<span>“万众创业贷(猪八戒)”是猪八戒网平台与重庆三峡银行联合打造的面向广大服务商的订单融资产品，以服务商的交易订单为依据，以金融科技手段为支撑，为猪八戒网的广大服务商提供“线上申请、智能审批、实时到账、方便快捷”的全流程全线上融资服务。</span>
				</div>
			</div>

			<div class="item-second">
				<img class="title" src="./images/serviceProvider/title-product.png" />
				<div class="item-content">
					<div class="item-card">
						<img src="./images/serviceProvider/icon-jike.png">
						<span>即刻贷</span>
						<i>60s全线上申请<br>最快3分钟到账</i>
						<i></i>
					</div>
					<div class="item-card">
						<img src="./images/serviceProvider/icon-diya.png">
						<span>0抵押</span>
						<i>订单就能贷<br>0抵押 0担保</i>
						<i></i>
					</div>
					<div class="item-card">
						<img src="./images/serviceProvider/icon-edu.png">
						<span>额度高</span>
						<i>最高额度50万<br>随借随还</i>
						<i></i>
					</div>
					<div class="item-card">
						<img src="./images/serviceProvider/icon-chengben.png">
						<span>成本低</span>
						<i>年利率低至9.50%<br>借1万元日利息仅2.64元<br>(推广期内)</i>
						<i></i>
					</div>
				</div>
			</div>

			<div class="item-third">
				<img class="title" src="./images/serviceProvider/title-contact.png" />
				<div class="item-content">
					<div class="item-card">
						<img src="./images/serviceProvider/icon-kefu.png">
						<span>客服热线</span>
						<i>023-88392602</i>
					</div>
					<div class="item-card">
						<img class="big" src="./images/serviceProvider/contact_qr.png">
						<span>微信咨询</span>
					</div>
					<div class="item-card">
						<img src="./images/serviceProvider/icon-email.png">
						<span>邮箱</span>
						<i>kangkang@zbj.com</i>
					</div>
				</div>
			</div>
		</div>
		<img src="./images/serviceProvider/bg-bottom.png" >
	</div>
</template>
<script>
import $ from 'jquery'
import QRCode from 'qrcodejs2'
export default {
	name: 'service-provider',
	data () {
		return {
			channelId: '',
			thirdPartyInfo: {},
			pageDomain: '',
		}
	},
	mounted() {
		console.log('进入mounted')
		this.pageDomain = window.ZBJInfo.pageDomain;
		console.log('window.ZBJInfo.pageDomain')
		this.$bus.$emit('ready');
		console.log('ready')
		let thirdParams = JSON.parse(this.$cookie.get('thirdPartyInfo') || '{}');
		console.log(this.$cookie.get('thirdPartyInfo'))
		console.log(thirdParams)
		this.channelId = thirdParams.channelId;
		this.clientId = thirdParams.clientId;
		this.thirdPartyInfo = JSON.parse(thirdParams.thirdPartyInfo || '{}');
		console.log(thirdParams['thirdPartyInfo'])
		this.showQrcode();
	},
	methods: {
		showQrcode(){
			$('.qrcode').html('');
			console.log('thirdPartyInfo:' + JSON.stringify(this.thirdPartyInfo))
			if(this.thirdPartyInfo.shopId && this.thirdPartyInfo.shopName){	
				let url = `${window.location.protocol}//exloan.${this.pageDomain}/openapi/ccqtgb/entity?resourcesKey=${this.channelId}&shopId=${this.thirdPartyInfo.shopId}&shopName=${this.thirdPartyInfo.shopName}`;
				console.log('url:' + url)
				let qrcode = new QRCode('qrcode', {  
						width: 180,  // 设置宽度 
						height: 180, // 设置高度
						text: url
				})
			}else {
				$('.qrcode').html('没有店铺参数，请重新进入');
			}
		},
	},
}
</script>
<style lang="less" scoped>
@import "..\..\..\global\css\mixin\mixin.less";
.content{
	width: 100%;
	height: 100%;
	text-align: center;
	background-color: #F5F8FF;
	min-width: 1920px;
	padding-bottom: 60px;
	p{
		padding: 20px 0px;
		font-size: 24px;
	}
	.qrcode{
		display: inline-block;
		margin: 5px;
		margin-left: 8px;
	}
	.title-bar {
		position:absolute;
		background: #0672DD40;
		min-width: 1150px;
		width: 100%;
		height: 80px;
		img {
			float: left;
			margin-left: 20px;
			-webkit-transform: translateY(50%);
      transform: translateY(50%);
		}
	}
	.title-banner {
		img {
			width: 100%;
			min-width: 1150px;
		}
	}
	.item-second {
		width: 1920px;
		height: 500px;
		margin-top: 160px;
		text-align: center;
		.title {
			width: 852px;
			height: 87px;
			color: #E0E4ED;
			line-height: 90px;
		}
		.item-content {
			text-align: center;
			width: 100%;
			margin-top: 30px;
			display: flex;
			align-items:center;
			justify-content:center;
		}
		.item-card {
			width: 280px;
			height: 360px;
			margin: 16px;
			background: #ffffff;
			border-radius: 20px;
			display: flex;
			flex-flow: column;
			align-items: center;
			// justify-content: center;
			img {
				margin-top: 50px;
				height: 70px;
			}
			span {
				margin-top: 20px;
				font-size: 35px;
				color: #8D6438;
			}
			i {
				margin-top: 20px;
				line-height: 32px;
				font-size: 22px;
				color: #555555;
			}
		}
	}

	.item-first {
		width: 1920px;
		height: 1036px;
		background: url('./images/serviceProvider/content-bg.png') no-repeat center;
		background-size: 1920px;
		.item-qrcode {
			position: absolute;
			width: 380px;
			height: 250px;
			margin-top: 340px;
			left: 752px;
			padding-top: 50px;
		}
		.item-content {
			position: absolute;
			width: 1200px;
			height: 190px;
			background: #FFFFFF;
			border-radius: 30px;
      margin-top: 900px;
			left: 302px;
			border-radius: 30px;
			text-align: left;
			padding-top: 30px;
			padding-left: 55px;
			padding-right: 50px;
			span {
				position: relative;
				font-size: 26px;
				line-height: 44px;
				font-weight: 500;
				color: #8D6438;
			}
		}
	}
	.item-third {
		width: 1920px;
		height: 500px;
		margin-top: 90px;
		text-align: center;
		.title {
			width: 643px;
			height: 88px;
			color: #E0E4ED;
			line-height: 90px;
		}
		.item-content {
			text-align: center;
			width: 100%;
			margin-top: 30px;
			display: flex;
			align-items:center;
			justify-content:center;
		}
		.item-card {
			width: 380px;
			height: 360px;
			margin: 16px;
			background: #ffffff;
			border-radius: 0px 0px 164px 164px;
			display: flex;
			flex-flow: column;
			align-items: center;
			// justify-content: center;
			img {
				margin-top: 50px;
				height: 90px;
				&.big {
					height: 150px;
				}
			}
			span {
				margin-top: 20px;
				font-size: 24px;
				line-height: 40px;
				color: #8D6438;
			}
			i {
				font-size: 30px;
				font-weight: 500;
				color: #555555;
			}
		}
	}

	.item-title {
		display: inline-block;
		h2 {
			position: relative;
			z-index: 1000;
			font-size: 40px;
			font-weight: 500;
			padding-top: 60px;
		}
		h3 {
			top: -30px;
			position: relative;
			line-height: 0px;
			z-index: 999;
			width: 553px;
			font-size: 36px;
			font-weight: bold;
			color: #343434;
			opacity: 0.11;
			&.big {
				font-size: 55px;
			}
		}

	}

	.title-line {
		div { 
			display: inline-block;
			width: 50px;
			height: 5px;
			background-color: #0672B2;
		}
	}
}
</style>


// WEBPACK FOOTER //
// serviceProvider.vue?7c45a6c3